/**
 * WorkshopDateWarning — the non-blocking 6-week lead notice in the Create
 * Workshop drawer (BON-508). Deliberately NOT a field error: it never disables
 * Continue or Create draft, it just makes sure a near-term workshop is created
 * knowingly.
 *
 * Warn-coloured, matching the publish modal's warning treatment (BON-469) so
 * "are you sure" reads differently from "you cannot" everywhere in the flow.
 * `heading` is for the Review step, where the next click actually creates.
 */
export function WorkshopDateWarning({
  message,
  heading,
}: {
  message: string | undefined;
  heading?: string;
}) {
  if (!message) return null;
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        padding: '8px 10px',
        borderRadius: 8,
        background: 'var(--nb-warn-soft)',
        border: '1px solid var(--nb-warn)',
      }}
    >
      {heading && (
        <span
          style={{ fontSize: 10, fontWeight: 800, letterSpacing: '.04em', color: 'var(--nb-warn)' }}
        >
          {heading}
        </span>
      )}
      <span style={{ fontSize: 11.5, color: 'var(--nb-ink-2)', lineHeight: 1.45 }}>{message}</span>
    </div>
  );
}
